
import { Skeleton } from "@/components/ui/skeleton";

export const DraftsTableSkeleton = () => (
  <div className="overflow-hidden rounded-xl border border-stone-200 dark:border-stone-700">
    <table className="w-full" role="table">
      <thead className="bg-stone-100 dark:bg-stone-800">
        <tr>
          <th scope="col" className="px-8 py-4 text-left text-sm font-semibold text-stone-500 dark:text-stone-500">Topic</th>
          <th scope="col" className="px-8 py-4 text-left text-sm font-semibold text-stone-500 dark:text-stone-500">Score</th>
          <th scope="col" className="px-8 py-4 text-left text-sm font-semibold text-stone-500 dark:text-stone-500">Date</th>
          <th scope="col" className="px-8 py-4" aria-label="Actions"></th>
        </tr>
      </thead>
      <tbody>
        {[...Array(5)].map((_, index) => (
          <tr key={index} className="border-t border-stone-200 dark:border-stone-700 bg-white dark:bg-stone-800">
            <td className="px-8 py-4">
              <Skeleton className="h-4 w-48 bg-stone-200 dark:bg-stone-700" />
            </td>
            <td className="px-8 py-4">
              <Skeleton className="h-4 w-12 bg-stone-200 dark:bg-stone-700" />
            </td>
            <td className="px-8 py-4">
              <Skeleton className="h-4 w-32 bg-stone-200 dark:bg-stone-700" />
            </td>
            <td className="px-8 py-4">
              <div className="flex justify-end gap-2">
                <Skeleton className="h-8 w-8 rounded-full bg-stone-200 dark:bg-stone-700" />
                <Skeleton className="h-8 w-8 rounded-full bg-stone-200 dark:bg-stone-700" />
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
